import { Alert, Box, Spinner } from '@factorialco/deprecated-design-system'
import { AtsJobApplicationCvSectionFragment } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import { CurriculumItem } from 'modules/ats/components/CurriculumItem'
import { CurriculumViewer } from 'modules/ats/components/CurriculumViewer'
import { CvDropzone } from 'modules/ats/components/CvDropzone'
import { useCandidateFiles } from 'modules/ats/hooks/candidateFiles'

interface Props {
  data: AtsJobApplicationCvSectionFragment
}

export const JobApplicationCvSection = ({ data }: Props) => {
  const { id, jobPosting, candidate } = data

  const {
    access: { id: accessId },
  } = useCurrentSession()

  const { loadingFiles, candidateCvFiles, bulkCreateCandidateFiles, creatingFiles } =
    useCandidateFiles({
      atsCandidateId: candidate.id,
    })

  // TO DO: add Skeleton
  if (loadingFiles) {
    return (
      <Box paddingY="s12" alignItems="center" justifyContent="center" height="full">
        <Spinner size="s40" />
      </Box>
    )
  }

  const currentApplicationCv = candidateCvFiles.find((file) => file.atsApplicationId === id)

  const otherCandidateApplicationCv = candidateCvFiles.find((file) => file.atsApplicationId !== id)

  const uploadCv = async (files: File[]) => {
    await bulkCreateCandidateFiles({
      atsCandidateId: candidate.id,
      resourceId: id,
      resourceType: 'application',
      authorId: accessId,
      authorType: 'access',
      files: [
        {
          attachment: files[0],
          category: 'cv',
        },
      ],
    })
  }

  const currentApplicationCvPreview = currentApplicationCv?.preview || currentApplicationCv?.file
  const otherApplicationCvPreview =
    otherCandidateApplicationCv?.preview || otherCandidateApplicationCv?.file

  return (
    <Box width="full" gap="s24" flexGrow>
      {currentApplicationCvPreview ? (
        <>
          <CurriculumViewer
            url={currentApplicationCvPreview.url}
            filename={currentApplicationCv?.file.filename}
            contentType={currentApplicationCvPreview.contentType}
          />
          <Box padding="s24" paddingTop="s0">
            <CurriculumItem jobTitle={jobPosting?.title} cv={currentApplicationCv} />
          </Box>
        </>
      ) : (
        <>
          {otherApplicationCvPreview ? (
            <>
              <CurriculumViewer
                url={otherApplicationCvPreview.url}
                contentType={otherApplicationCvPreview.contentType}
                filename={otherApplicationCvPreview.filename}
              />
              <Box padding="s24" paddingTop="s0" gap="s24">
                <Alert color="warning">
                  {i18n.t('ats.candidates.files.application_files.other_application_file_warn')}
                </Alert>
                <CvDropzone onDrop={uploadCv} disabled={creatingFiles} />
              </Box>
            </>
          ) : (
            <Box padding="s16" flexGrow>
              <CvDropzone onDrop={uploadCv} disabled={creatingFiles} fullSize />
            </Box>
          )}
        </>
      )}
    </Box>
  )
}
